import { combineReducers } from 'redux';
import delayCodesReducer from './DelayCodesReducer';
import aircraftReducer from './AircraftReducer';
import maintDelaysReducer from './MaintDelaysReducer';
import fltopsDelaysReducer from './FltopsDelaysReducer';
// The rootReducer combines all the individual reducers into a single reducer function.
// This is the main reducer that will be passed to the Redux store.
// To add a new reducer, import it at the top and include it in the combineReducers function.

const rootReducer = combineReducers({
  delayCodesState: delayCodesReducer,
  aircraftState: aircraftReducer,
  maintDelaysState: maintDelaysReducer,
  fltopsDelaysState: fltopsDelaysReducer,
  
});

// This approach is useful because it allows you to manage different parts of the state
// independently with separate reducers, making the code more modular and easier to maintain.

export default rootReducer;